define('drops/dynamicImage/dynamicImage',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/tooltip',
    'lq/dynamicContentImage',
    'lq',
    'lq/imageSize',
    'lq/onlongpress'
], function ($, Drop, Style, util, Tooltip, dynamicContentImage, lq, imageSize, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            horizontalImageAlignment: 'center',
            verticalImageAlignment: 'center',
            thumbnailFileType: 'png',
            selectedResizeOption: 'Stretch Image',
            title: {
                option: Tooltip.hardcoded
            },
            notOptimise: false,
            optimisationLevel: 0
        }
    };

    function DynamicImage(options) {
        Drop.call(this, $('<div />'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.$image = $('<div />')
            .css({
                'width': '100%',
                'height': '100%',
                'overflow': 'hidden'
            })
            .appendTo(this.$element);

        this.$element
            .addClass('boxToBorderSize');

        this.$image
            .addClass('loading');

        Style.renderStyles(this, null, this.$image);

        this.tooltip = new Tooltip(this, this.data.title, this.$image);

        this.hideWhenNecessary();

        this.applyEventTrigger('mouseEnter', 'mouseenter');
        this.applyEventTrigger('mouseLeave', 'mouseleave');
        this.addEventsToBeCanceledAndCanceledBy('mouseEnter', 'mouseLeave');
    };

    Drop.extend(DynamicImage, Drop);

    DynamicImage.typeName = 'DynamicImage';

    DynamicImage.prototype.onResizeOptions = [
        { key: 'Stretch Image', value: 'Stretch Image' },
        { key: 'No-Resize', value: 'No-Resize' },
        { key: 'Keep Ratio, Show Complete Image', value: 'Keep Ratio, Show Complete Image' },
        { key: 'fillKeepRatio', value: 'Fill, keep ratio' }
    ];

    DynamicImage.prototype.horizontalAlignmentOptions = [
        { key: 'left', value: 'Left' },
        { key: 'center', value: 'Center' },
        { key: 'right', value: 'Right' }
    ];

    DynamicImage.prototype.verticalAlignmentOptions = [
        { key: 'top', value: 'Top' },
        { key: 'center', value: 'Center' },
        { key: 'bottom', value: 'Bottom' }
    ];

    DynamicImage.prototype.thumbnailFileTypes = [
        { key: 'png', value: 'PNG (lossless)' },
        { key: 'jpeg100', value: 'JPEG - highest quality' },
        { key: 'jpeg75', value: 'JPEG - medium quality' },
        { key: 'jpeg50', value: 'JPEG - low quality' },
        { key: 'jpeg25', value: 'JPEG - very low quality' },
        { key: 'jpeg10', value: 'JPEG - extreme low quality' },
        { key: 'jpeg0', value: 'JPEG - max compression' }
    ];

    DynamicImage.prototype.preRender = function () {
        this.tooltip.update();
        this.piping.visibility.apply(this);

        this.initialize();
        this.setImageScaling();
        this.applyPosition();
    };

    DynamicImage.prototype.initialize = function () {
        new OnLongPress().applyLongPressOnElement(this.$element, this);

        if (this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            this.$element.addClass('clickable');
        }
    };

    // todo unify Image and DynamicImage
    DynamicImage.prototype.setImageScaling = function () {
        if (this.data.selectedResizeOption === 'Stretch Image')
            this.$image.css('background-size', '100% 100%');
        else if (this.data.selectedResizeOption === 'Keep Ratio, Show Complete Image')
            this.$image.css({
                'background-size': 'contain',
                'background-repeat': 'no-repeat',
                'background-position': this.data.horizontalImageAlignment + ' ' + this.data.verticalImageAlignment
            });
        else if (this.data.selectedResizeOption === 'No-Resize')
            this.$image.css({
                // When generating a thumbnail for high resolution devices we have to generate an image that has
                // twice the width and twice the height as the drop. In that case we can't set the size to 'auto'
                // because that would give the image twice its size in the browser
                'background-size': this.data.useThumbnail && imageSize.hasHighPixelRatio() ? 'contain' : 'auto',
                'background-repeat': 'no-repeat'
            });
        else if (this.data.selectedResizeOption === 'fillKeepRatio')
            this.$image.css({
                'background-size': 'cover',
                'background-repeat': 'no-repeat',
                'background-position': this.data.horizontalImageAlignment + ' ' + this.data.verticalImageAlignment
            });
    };

    DynamicImage.prototype.clearValue = function () {
        this.$image
            .css('background-image', '');
        this.hideWhenNecessary();
    };

    DynamicImage.prototype.hideWhenNecessary = function () {
        if (this.data.hideWhenEmpty)
            this.hide();
    };

    DynamicImage.prototype.setValue = function (update) {
        this.$image
            .removeClass('loading');

        var value = util.convertListOfKeyValuesToObject(update.value);

        if (!value) {
            this.clearValue();
        } else if ($.type(value) === 'string') {
            var regex = /data:image\/[^;]+;base64[^"]+/g;
            if (value.match(regex)) {
                this.updateImage('"' + value + '"', '');
            } else {
                var srcPath = this.getPathFromSrcString(value);
                this.updateImage(srcPath, '');
            }
        } else {
            var url = update.value.url || update.value.Url;

            if (url) {
                var documentPath = this.getPathFromSrcString(url);

                if (documentPath)
                    this.updateImage(documentPath, update.value.filename || update.value.Filename);
                else
                    this.clearValue();
            }
        }
    };

    DynamicImage.prototype.updateImage = function(src, alt) {
        this.$image
            .css('background-image', 'url(' + src + ')')
            .attr('alt', alt);

        if (this.data.hideWhenEmpty)
            this.show();
    };

    DynamicImage.prototype.getPathFromSrcString = function (src) {
        return dynamicContentImage.getPath({
            imageName: src,
            useThumbnail: this.data.useThumbnail,
            resizeOption: this.data.selectedResizeOption,
            thumbnailFileType: this.data.thumbnailFileType,
            size: this.data.size
        });
    };

    return DynamicImage;
});
